import { combineReducers } from "redux";
import {
  DEFAULT_STATE,
  DEFAULT_STATE_FF_EF,
  sidebarToggleItems,
} from "../utility/constants";
import moment from "moment";

const createReducer = (reducerName, defaultStateParam) => {
  const defaultState = defaultStateParam || DEFAULT_STATE;
  return (state = defaultState, action) => {
    switch (action.type) {
      case `${reducerName}_PENDING`:
      case `${reducerName}_FULFILLED`:
      case `${reducerName}_REJECTED`:
        return Object.assign({}, action.payload);
      default:
        return state;
    }
  };
};

const createStaticReducer = (reducerName, defaultStateParam) => {
  const defaultState = defaultStateParam || DEFAULT_STATE;
  return (state = defaultState, action) => {
    switch (action.type) {
      case `${reducerName}`:
        return Object.assign({}, action.payload);
      default:
        return state;
    }
  };
};

const rootReducer = combineReducers({
  sidebar: createStaticReducer("TOGGLE_SIDEBAR", {
    visible: true,
  }),
  sidebarMenuToggle: createStaticReducer(
    "TOGGLE_SIDEBAR_MENU",
    sidebarToggleItems
  ),

  loginSection: createStaticReducer("LOGIN_SECTION", {
    loginType: "email",
  }),

  enterEmail: createReducer("ENTER_EMAIL", DEFAULT_STATE_FF_EF),
  verifyOTP: createReducer("VERIFY_OTP", DEFAULT_STATE_FF_EF),
  otpCreation: createReducer("OTP_CREATION", DEFAULT_STATE_FF_EF),
  createPassword: createReducer("CREATE_PASSWORD", DEFAULT_STATE_FF_EF),
  enterPassword: createReducer("ENTER_PASSWORD", DEFAULT_STATE_FF_EF),

  logout: createReducer("LOGOUT", {
    logout: false,
  }),

  countries: createReducer("GET_COUNTRIES", DEFAULT_STATE_FF_EF),
  districts: createReducer("GET_DISTRICTS", DEFAULT_STATE_FF_EF),

  currentTab: createStaticReducer("CURRENT_TAB", {
    currentTab: "Accepted trips",
  }),

  bookingAdd: createReducer("BOOKING_ADD", DEFAULT_STATE_FF_EF), //
  b2bBookingsById: createReducer("B2B_BOOKINGS_BY_ID", DEFAULT_STATE_FF_EF), //
  getBusinessUsers: createReducer("BUSINESS_USER_GET", DEFAULT_STATE_FF_EF),

  getLocationHistory: createReducer(
    "GET_LOCATION_HISTORY",
    DEFAULT_STATE_FF_EF
  ), //
  updatePickupLocation: createReducer(
    "UPDATE_PICKUP_LOCATION",
    DEFAULT_STATE_FF_EF
  ), //
  vehicleTypes: createReducer("GET_VEHICLE_TYPES", DEFAULT_STATE_FF_EF), //

  settingsConfig: createReducer("GET_SETTINGS_CONFIG", DEFAULT_STATE_FF_EF),

  admins: createReducer("GET_ADMINS", DEFAULT_STATE_FF_EF),
  adminAdd: createReducer("ADMIN_ADD", DEFAULT_STATE_FF_EF),
  adminDelete: createReducer("ADMIN_DELETE", DEFAULT_STATE_FF_EF),
  employees: createReducer("GET_EMPLOYEES", DEFAULT_STATE_FF_EF),
  employeeAdd: createReducer("EMPLOYEES_ADD", DEFAULT_STATE_FF_EF),
  agents: createReducer("GET_AGENTS", DEFAULT_STATE_FF_EF),
  agentAdd: createReducer("AGENT_ADD", DEFAULT_STATE_FF_EF),
  agentById: createReducer("AGENT_BY_ID", DEFAULT_STATE_FF_EF),

  configCheck: createReducer("CONFIG_CHECK", DEFAULT_STATE_FF_EF),
  pendingList: createReducer("GET_PENDING_LIST", DEFAULT_STATE_FF_EF),
  inProgressListEts: createReducer(
    "GET_INPROGRESS_LIST_ETS",
    DEFAULT_STATE_FF_EF
  ),
  completedListEts: createReducer(
    "GET_COMPLETED_LIST_ETS",
    DEFAULT_STATE_FF_EF
  ),
  inProgressList: createReducer("GET_INPROGRESS_LIST", DEFAULT_STATE_FF_EF),
  completedList: createReducer("GET_COMPLETED_LIST", DEFAULT_STATE_FF_EF),
  corporateApiList: createReducer(
    "GET_CORPORATE_API_LIST",
    DEFAULT_STATE_FF_EF
  ),
  corporateApiDetails: createReducer(
    "GET_CORPORATE_API_DETAILS",
    DEFAULT_STATE_FF_EF
  ),
  apiToken: createReducer("GET_ API_TOKEN", DEFAULT_STATE_FF_EF),
  tripListDetail: createReducer("GET_TRIP_DETAILS", DEFAULT_STATE_FF_EF),
  etsTripListDetail: createReducer("GET_ETS_TRIP_DETAILS", DEFAULT_STATE_FF_EF),
  etsVehicleInfo: createReducer("GET_ETS_VEHICLE_INFO", DEFAULT_STATE_FF_EF),
  bookingsStatus: createReducer("GET_BOOKING_STATUS", DEFAULT_STATE_FF_EF),
  updateBookingsStatus: createReducer(
    "UPDATE_TRIP_DETAILS",
    DEFAULT_STATE_FF_EF
  ),
  updateBookingDetails: createReducer(
    "UPDATE_BOOKING_DETAILS",
    DEFAULT_STATE_FF_EF
  ),

  superAdmins: createReducer("GET_SUPER_ADMINS", DEFAULT_STATE_FF_EF),
  superAdminAdd: createReducer("SUPER_ADMIN_ADD", DEFAULT_STATE_FF_EF),
  superAdminDelete: createReducer("SUPER_ADMIN_DELETE", DEFAULT_STATE_FF_EF),

  addCSV: createReducer("ADD_CSV", DEFAULT_STATE_FF_EF),

  tripSheetData: createReducer("GET_TRIP_SHEET", DEFAULT_STATE_FF_EF),
  tripSheetGeneralData: createReducer(
    "GET_TRIP_SHEET_GENERAL",
    DEFAULT_STATE_FF_EF
  ),
  tripListFilters: createStaticReducer("TRIP_LIST_FILTERS", {
    fromDate: moment().format("DD-MM-YYYY"),
    toDate: "",
  }),
  employeeDetail: createReducer("GET_EMPLOYEE_DETAILS", DEFAULT_STATE_FF_EF),
  corporateDD: createReducer("GET_CORPORATEDD", DEFAULT_STATE_FF_EF),
  branchListDD: createReducer("GET_BRANCH_DD", DEFAULT_STATE_FF_EF),
  tmcBookingAdd: createReducer("TMC_BOOKING_ADD", DEFAULT_STATE_FF_EF),
  tmcBookingCancel: createReducer("GET_BOOKING_CANCEL", DEFAULT_STATE_FF_EF),

  associatesList: createReducer("GET_ASSOCIATES_LIST", DEFAULT_STATE_FF_EF),
  associatesAdd: createReducer("ASSOCIATES_ADD", DEFAULT_STATE_FF_EF),
  companies: createReducer("GET_COMPANIES", DEFAULT_STATE_FF_EF),
  companyAdd: createReducer("COMPANY_ADD", DEFAULT_STATE_FF_EF),
  companyById: createReducer("COMPANY_BY_ID", DEFAULT_STATE_FF_EF),
  branchesList: createReducer("GET_BRANCHES_LIST", DEFAULT_STATE_FF_EF),
  branchAdd: createReducer("BRANCH_ADD", DEFAULT_STATE_FF_EF),
  branchById: createReducer("BRANCH_BY_ID", DEFAULT_STATE_FF_EF),
  driverList: createReducer("GET_DRIVER_LIST", DEFAULT_STATE_FF_EF),
  driverAdd: createReducer("DRIVER_ADD", DEFAULT_STATE_FF_EF),
  vehicleList: createReducer("GET_VEHICLE_LIST", DEFAULT_STATE_FF_EF),
  vehicleAdd: createReducer("VEHICLE_ADD", DEFAULT_STATE_FF_EF),
  vehicleMakeDD: createReducer("GET_VEHICLE_MAKE_DD", DEFAULT_STATE_FF_EF),
  vehicleModelsDD: createReducer("GET_VEHICLE_MODEL_DD", DEFAULT_STATE_FF_EF),
  vehicleYearsDD: createReducer("GET_VEHICLE_YEAR_DD", DEFAULT_STATE_FF_EF),
  vehicleColorsDD: createReducer("GET_VEHICLE_COLOR_DD", DEFAULT_STATE_FF_EF),
  vehicleEnginesDD: createReducer("GET_VEHICLE_ENGINE_DD", DEFAULT_STATE_FF_EF),
  getDriverData: createReducer("GET_DRIVER_BY_PHONE", DEFAULT_STATE_FF_EF),
  getVehicleData: createReducer(
    "GET_VEHICLE_BY_REGISTRATION",
    DEFAULT_STATE_FF_EF
  ),
  bookingsById: createReducer("BOOKINGS_BY_ID", DEFAULT_STATE_FF_EF),
  getProfileData: createReducer("GET_PROFILE", DEFAULT_STATE_FF_EF),
  reportList: createReducer("GET_REPORT_LIST", DEFAULT_STATE_FF_EF),
  bookingAnalytics: createReducer("GET_ANALYTICS", DEFAULT_STATE_FF_EF),
  statusChange: createReducer("STATUS_CHANGE", DEFAULT_STATE_FF_EF),
  driverAssign: createReducer("DRIVER_ASSIGN", DEFAULT_STATE_FF_EF),
  tripUpdate: createReducer("TRIP_UPDATE", DEFAULT_STATE_FF_EF),

  operatingAreaList: createReducer(
    "GET_OPERATING_AREA_LIST",
    DEFAULT_STATE_FF_EF
  ),
  getLocalConfig: createReducer("GET_LOCAL_CONFIG", DEFAULT_STATE_FF_EF),
  localConfigById: createReducer("LOCAL_CONFIG_BY_ID", DEFAULT_STATE_FF_EF),
  localPricingBaseList: createReducer(
    "GET_LOCAL_PRICING_BASE_LIST",
    DEFAULT_STATE_FF_EF
  ),
  localPricingBaseAdd: createReducer(
    "ADD_LOCAL_PRICING_BASE",
    DEFAULT_STATE_FF_EF
  ),
  localPricingDynamicList: createReducer(
    "GET_LOCAL_PRICING_DYNAMIC_LIST",
    DEFAULT_STATE_FF_EF
  ),

  localDynamicPricingAdd: createReducer(
    "ADD_LOCAL_DYNAMIC_PRICING",
    DEFAULT_STATE_FF_EF
  ),
  localRentalPricing: createReducer(
    "GET_LOCAL_RENTAL_PRICING",
    DEFAULT_STATE_FF_EF
  ),
  localRentalPricingAdd: createReducer(
    "ADD_LOCAL_RENTAL_PRICING",
    DEFAULT_STATE_FF_EF
  ),
  localDowntimePricing: createReducer(
    "GET_LOCAL_DOWNTIME_PRICING",
    DEFAULT_STATE_FF_EF
  ),
  localDowntimePricingAdd: createReducer(
    "ADD_LOCAL_DOWNTIME_PRICING",
    DEFAULT_STATE_FF_EF
  ),

  localDowntimeHotspotPricing: createReducer(
    "GET_LOCAL_DOWNTIME_HOTSPOT_PRICING",
    DEFAULT_STATE_FF_EF
  ),
  localAdditionalPricing: createReducer(
    "GET_LOCAL_ADDITIONAL_PRICING",
    DEFAULT_STATE_FF_EF
  ),
  localHotspotDynamicList: createReducer(
    "GET_LOCAL_HOTSPOT_DYNAMIC_LIST",
    DEFAULT_STATE_FF_EF
  ),
  localAdditionalHotspotPricing: createReducer(
    "GET_LOCAL_ADDITIONAL_HOTSPOT_PRICING",
    DEFAULT_STATE_FF_EF
  ),
  localRentalHotspotPricing: createReducer(
    "GET_LOCAL_RENTAL_HOTSPOT_PRICING",
    DEFAULT_STATE_FF_EF
  ),
  localRentalHotspotPricingAdd: createReducer(
    "ADD_LOCAL_RENTAL_HOTSPOT_PRICING",
    DEFAULT_STATE_FF_EF
  ),

  googleCustomPlaces: createReducer(
    "GOOGLE_CUSTOM_PLACES",
    DEFAULT_STATE_FF_EF
  ),
  distanceMatrix: createReducer("GET_DISTANCE_MATRIX", DEFAULT_STATE_FF_EF),
  placesDetail: createReducer("GET_PLACES_DETAIL", DEFAULT_STATE_FF_EF),
});

export default rootReducer;
